export const emailDomainAuthenticatorConstants = {
  GET_BYID_REQUEST: "GET_BYID_EMAILDOMAINAUTHENTICATOR_REQUEST",
  GET_BYID_SUCCESS: "GET_BYID_EMAILDOMAINAUTHENTICATOR_SUCCESS",
  GET_BYID_FAILURE: "GET_BYID_EMAILDOMAINAUTHENTICATOR_FAILURE",
  GET_REQUEST: "GET_EMAILDOMAINAUTHENTICATOR_REQUEST",
  GET_SUCCESS: "GET_EMAILDOMAINAUTHENTICATOR_SUCCESS",
  GET_FAILURE: "GET_EMAILDOMAINAUTHENTICATOR_FAILURE",
  CREATE_REQUEST: "CREATE_EMAILDOMAINAUTHENTICATOR_REQUEST",
  CREATE_SUCCESS: "CREATE_EMAILDOMAINAUTHENTICATOR_SUCCESS",
  CREATE_FAILURE: "CREATE_EMAILDOMAINAUTHENTICATOR_FAILURE",
  UPDATE_REQUEST: "UPDATE_EMAILDOMAINAUTHENTICATOR_REQUEST",
  UPDATE_SUCCESS: "UPDATE_EMAILDOMAINAUTHENTICATOR_SUCCESS",
  UPDATE_FAILURE: "UPDATE_EMAILDOMAINAUTHENTICATOR_FAILURE",
  DELETE_REQUEST: "DELETE_EMAILDOMAINAUTHENTICATOR_REQUEST",
  DELETE_SUCCESS: "DELETE_EMAILDOMAINAUTHENTICATOR_SUCCESS",
  DELETE_FAILURE: "DELETE_EMAILDOMAINAUTHENTICATOR_FAILURE",
};
